<script lang="ts" setup>
  import { defineComponent, onMounted, reactive } from "vue";
  import { useRoute, useRouter } from 'vue-router';

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/clientesContratosService";
  import { corrigirImagensContrato } from "@/utils/funcoes";

  //componentes
  import ReportView from "@/components/ReportView/Index.vue";

  const route = useRoute();
  const router = useRouter();

  var controle = reactive({
    filtros: {
      paginaAtual: 1,
      tamanhoPagina: 1
    } as unknown as service.Filtros,
    model: {} as service.Contrato,


    status: "",
    erro: "",
  })

  onMounted(async ()=>{
    pesquisar();
  })

  async function pesquisar() {

    if (route.params.id) {
      controle.filtros.contratoId = parseInt(route.params.id as string);
    }

    service.obterPorId(controle.filtros.contratoId)
    .then(r=> {
      controle.model = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

function imprimir() {
  window.print();
}

</script>

<template>

  <BreadCrumb PageTitle="Contratos" 
    :items="[ 
      { label: 'Contratos', to: '/contatos' } ]" />

  <div class="div-contrato">
    <div class="contrato" v-html="corrigirImagensContrato(controle.model.texto)"></div>
  </div>

  <div class="col-md-12 d-print-none">
   
    <button class="btn btn-primary btn-sm me-2" @click="router.go(-1)">
     <i class="fa fa-arrow-left"></i> Voltar
   </button>

    <button class="btn btn-secondary btn-sm" @click="imprimir()">
      <i class="flaticon-printer"></i> Imprimir
    </button>


    <RouterLink class="btn btn-primary btn-sm float-end" to="/">
      <i class="fa fa-times"></i> Fechar
    </RouterLink>
  </div>

</template>

<style lang="css" scoped>

.div-contrato{
    background-color: white;
    padding: 15px;
    border: 1px solid #a7a7a7;
    overflow-y: auto;
    margin-bottom: 10px;
    height: calc(100vh - 150px);
}

/*criar um css para o contrato, para que fique mais bonito, na impressao */
@media print {
  .div-contrato {
    height: auto;
    border: none;
  }
}

/* criar um css para que fique totalmente visivel e rolavel quando for tablet virado */
@media (max-width: 768px) and (orientation: landscape) {
  .div-contrato {
    height: auto;
    border: none;
  }
}

</style>